import { FoldLeftIcon, FoldRightIcon } from "@/components/fun-ui/icons";
import { Tip } from "@/components/fun-ui/Tip";
import { useSubjectId } from "@/components/subjects/hooks/usePathParams";
import { cn } from "@/lib/utils";
import { useAiColSidebarCollapsed } from "@/stores/localStore";

export const SemiCircleWithShadow = () => {
  const subjectId = useSubjectId();
  const {
    collapsed,
    setCollapsed,
  } = useAiColSidebarCollapsed(subjectId);

  return (
    <div
      onClick={() => {
        setCollapsed(!collapsed);
      }}
      className="absolute z-10 top-1/2 -translate-y-1/2 left-0 -translate-x-1/2 w-8 h-16 rounded-full cursor-pointer"
    >
      {/* 左边半圆带阴影 */}
      <div className="absolute w-1/2 h-1/2 top-1/2 -translate-y-1/2 bg-background
       rounded-l-full shadow-[0_3px_8px_0_rgba(0,0,0,0.16)]"></div>
      {/* 右边覆盖长方形 */}
      <div className="absolute w-1/2 h-full right-0 top-1/2 -translate-y-1/2 bg-background"></div>

      <Tip
        side="left"
        sideOffset={8}
        label={collapsed ? "展开" : "收起"}
      >
        <div
          className={cn(
            "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex",
          )}
        >
          {collapsed ? <FoldLeftIcon /> : <FoldRightIcon />}
        </div>
      </Tip>
    </div>
  );
};